var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitlab = function SvgGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 236"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M128.075 236.075 175.18 91.104H80.97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "M128.075 236.075 80.97 91.104H14.956z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "M14.956 91.104.642 135.16a9.74 9.74 0 0 0 3.537 10.89l123.896 90.025z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M14.956 91.104H80.97L52.6 3.79c-1.46-4.493-7.816-4.493-9.275 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "m128.075 236.075 47.104-144.971h66.014z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "m241.193 91.104 14.314 44.056a9.74 9.74 0 0 1-3.537 10.89l-123.895 90.025z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M241.193 91.104H175.18L203.55 3.79c1.46-4.493 7.816-4.493 9.275 0z"
  })));
};
export default SvgGitlab;